var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticStyle:{"border-top":"1px solid rgba(0, 0, 0, 0.12)"},attrs:{"height":"57","fixed":"","inset":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }